import { ISettingsState } from '../../models';
import {
    SET_ALL_SETTINGS,
    UPDATE_ACCESS_TOKEN,
    UPDATE_DEFAULT_MONTHLY_INCOME,
    UPDATE_TOGGLE_SETTINGS
} from '../actionTypes';

const initialState = {
    defaultMonthlyIncome: 0,
    accessToken: '',
    toggles: {
        autoLogoutOnClose: false,
        dailyReminder: false,
        monthEndAlert: false
    }
} as ISettingsState;

export default function (state = initialState, action: any) {
    switch (action.type) {
        case SET_ALL_SETTINGS:
            return {
                defaultMonthlyIncome: action.settings.defaultIncome,
                accessToken: action.settings.accessToken,
                toggles: {
                    dailyReminder: action.settings.dailyReminder,
                    monthEndAlert: action.settings.monthEndAlert,
                    autoLogoutOnClose: action.settings.autoLogoutOnClose
                }
            };
        case UPDATE_DEFAULT_MONTHLY_INCOME:
            return {
                ...state,
                defaultMonthlyIncome: action.defaultIncome
            };
        case UPDATE_ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.accessToken
            };
        case UPDATE_TOGGLE_SETTINGS:
            return {
                ...state,
                toggles: action.toggles
            };
        default:
            return state;
    }
}
